import './people_detail.scss';
